<div fxLayout="column" class="container sam-padding">
   <div fxFlex="1" fxLayout="row" fxFlexAlign="end" fxLayoutGap="5px">
      <div
         kendoTooltip
         title="{{
            !(isAddingBrickPossibleInBrickWall$ | async) ? ('brick.brick-management.not-enough-space' | translate) : ''
         }}"
      >
         <button
            kendoButton
            *ngIf="!addingBrickSpecialHandlingByOtherBrickInstanceId && (allowedInBrickWall$ | async)"
            (click)="addBrickToBrickWall(false)"
            [disabled]="!(isAddingBrickPossibleInBrickWall$ | async)"
         >
            <fa-icon class="sam-margin-right" [icon]="plusIcon"></fa-icon>
            <div class="sam-button-text">
               {{ 'brick.brick-management.add_to_brickwall_button' | translate }}
            </div>
         </button>
      </div>
      <div
         kendoTooltip
         title="{{
            !(isAddingBrickPossibleInPilotPanel$ | async) ? ('brick.brick-management.not-enough-space' | translate) : ''
         }}"
      >
         <button
            kendoButton
            *ngIf="!addingBrickSpecialHandlingByOtherBrickInstanceId && (allowedInPilotPanel$ | async)"
            (click)="addBrickToBrickWall(true)"
            [disabled]="!(isAddingBrickPossibleInPilotPanel$ | async)"
         >
            <fa-icon class="sam-margin-right" [icon]="plusIcon"></fa-icon>
            <div class="sam-button-text">
               {{ 'brick.brick-management.add_to_pilotpanel_button' | translate }}
            </div>
         </button>
      </div>
      <div
         kendoTooltip
         *ngIf="addingBrickSpecialHandlingByOtherBrickInstanceId"
         title="{{
            !(isAddingBrickPossibleSpecial$ | async) ? ('brick.brick-management.not-enough-space' | translate) : ''
         }}"
      >
         <button
            kendoButton
            (click)="addBrickToBrickWallByLayoutBrick(addingBrickSpecialHandlingByOtherBrickInstanceId)"
            [disabled]="!(isAddingBrickPossibleSpecial$ | async)"
         >
            <fa-icon class="sam-margin-right" [icon]="plusIcon"></fa-icon>
            {{ 'brick.brick-management.add_to_custom' | translate }}
         </button>
      </div>
   </div>
</div>
